export default __webpack_public_path__ + "media/images/9-4ce42422e5e8c13ae7fc0dde2c55a750.jpg";